import { RIGHTS_IS_CREATE, RIGHTS_SALE_PLANS } from '@app/constants';
import { useAccessRights } from '@app/hooks';

export const useSalePlansPageTable = () => {
  const { hasUserRight: hasUserRightToCreateSalePlans } = useAccessRights(
    RIGHTS_SALE_PLANS,
    RIGHTS_IS_CREATE
  );

  return {
    hasUserRightToCreateSalePlans,
  };
};
